/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTAXSCALE } from './IAPTAXSCALE';
import {
    IAPTAXSCALEFromJSON,
    IAPTAXSCALEFromJSONTyped,
    IAPTAXSCALEToJSON,
} from './IAPTAXSCALE';
import type { IAPTTAXDIRECTIVETYPE } from './IAPTTAXDIRECTIVETYPE';
import {
    IAPTTAXDIRECTIVETYPEFromJSON,
    IAPTTAXDIRECTIVETYPEFromJSONTyped,
    IAPTTAXDIRECTIVETYPEToJSON,
} from './IAPTTAXDIRECTIVETYPE';

/**
 * 
 * @export
 * @interface TaxRateViewModel
 */
export interface TaxRateViewModel {
    /**
     * 
     * @type {IAPTAXSCALE}
     * @memberof TaxRateViewModel
     */
    taxScaleId?: IAPTAXSCALE;
    /**
     * 
     * @type {number}
     * @memberof TaxRateViewModel
     */
    taxRatePercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof TaxRateViewModel
     */
    taxDirectiveNumber?: string;
    /**
     * 
     * @type {IAPTTAXDIRECTIVETYPE}
     * @memberof TaxRateViewModel
     */
    taxDirectiveTypeId?: IAPTTAXDIRECTIVETYPE;
}

/**
 * Check if a given object implements the TaxRateViewModel interface.
 */
export function instanceOfTaxRateViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TaxRateViewModelFromJSON(json: any): TaxRateViewModel {
    return TaxRateViewModelFromJSONTyped(json, false);
}

export function TaxRateViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxRateViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taxScaleId': !exists(json, 'TaxScaleId') ? undefined : IAPTAXSCALEFromJSON(json['TaxScaleId']),
        'taxRatePercentage': !exists(json, 'TaxRatePercentage') ? undefined : json['TaxRatePercentage'],
        'taxDirectiveNumber': !exists(json, 'TaxDirectiveNumber') ? undefined : json['TaxDirectiveNumber'],
        'taxDirectiveTypeId': !exists(json, 'TaxDirectiveTypeId') ? undefined : IAPTTAXDIRECTIVETYPEFromJSON(json['TaxDirectiveTypeId']),
    };
}

export function TaxRateViewModelToJSON(value?: TaxRateViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'TaxScaleId': IAPTAXSCALEToJSON(value.taxScaleId),
        'TaxRatePercentage': value.taxRatePercentage,
        'TaxDirectiveNumber': value.taxDirectiveNumber,
        'TaxDirectiveTypeId': IAPTTAXDIRECTIVETYPEToJSON(value.taxDirectiveTypeId),
    };
}

